var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "app-side-menu",
    { attrs: { "min-width": 18, "fixed-menu": false } },
    [
      _c(
        "aside",
        {
          staticClass: "menu",
          attrs: { slot: "side-menu" },
          slot: "side-menu",
        },
        [
          _c("ul", { staticClass: "menu-list" }, [
            _c(
              "li",
              [
                _c("bulma-autocomplete", {
                  staticClass: "is-uppercase",
                  attrs: {
                    value: _vm.quoteNo,
                    data: _vm.quotes,
                    field: "quoteNoRef",
                    "keep-first": true,
                    loading: _vm.isSearchingQuote,
                    expanded: true,
                    placeholder: "Quote No.",
                  },
                  on: { input: _vm.searchQuote, select: _vm.selectQuote },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column" }, [
                              _c("span", [
                                _vm._v(_vm._s(props.option.quoteNoRef)),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "column is-flex is-justify-content-flex-end",
                              },
                              [
                                _c("div", { staticClass: "tags" }, [
                                  props.option.hasOrm
                                    ? _c(
                                        "span",
                                        { staticClass: "tag is-primary" },
                                        [_vm._v(" ORM ")]
                                      )
                                    : _vm._e(),
                                  props.option.hasPnet
                                    ? _c(
                                        "span",
                                        { staticClass: "tag is-primary" },
                                        [_vm._v(" PNET ")]
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
          _c("hr"),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }